import React from 'react';
import championShip2025Image from './campeonato_aire_libre_2025.jpeg';

export const DownLoadPoster2025 = (): React.ReactElement => {

    return (
        <img        
            src={championShip2025Image}
            alt='Campeonato de las provincias de Valencia y Castellón al aire libre 2025'
        />
    )
}